import {axios, API, SendRequest} from '@/imports-files/pages/admins/dashboard/clients/edit';

export class DownloadFileFromEmail extends SendRequest {

  async serviceDownloadFileFromEmail(params, job_application_id) 
  {
      try {
        const result = await axios.get(API.client.applicant.DOWNLOAD_ATTACHMENTS.replace('$job_application_id', job_application_id),
            {
                params: params,
                headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
      } catch (error) {
        return error;
      }
    }
}
